import React, { useContext } from 'react';
import { MyComponentType } from '../component-factory/component-types';
import { ComponentIdEnum } from '../component-factory/ComponentIdEnum';
import { Props } from '../editor/ComponentBasicRender';
import { DropContainer } from '../HOC';
import { PageEditorStoreContext } from '../store/PageEditorStore';
import { ElementConfigType } from '../store/type';

const EmptyContainer = (props: ElementConfigType) => {
  const { id } = props;
  const pageEditorStore = useContext(PageEditorStoreContext);

  return (
    <>
      <props.ComponentBasicRender
        wrapperId={id}
        className={`w-full h-full ${pageEditorStore.isRenderHtml ? '' : 'p-1'}`}
        {...props}
        key={props.nodeId}
      />
    </>
  );
};

export const EmptyContainerHOC: MyComponentType<Props> = (props: any) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  return (
    <>
      {pageEditorStore.isRenderHtml ? (
        <EmptyContainer {...props} />
      ) : (
        <DropContainer {...props}>
          <EmptyContainer {...props} />
        </DropContainer>
      )}
    </>
  );
};

EmptyContainerHOC.definition = {
  id: ComponentIdEnum.EMPTY_CONTAINER_COMPONENT,
  name: '空白容器',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/D8AIxW3Fm11p6Of3ZinKF.png',
  config: {},
  privateSchema: {},
  category: 'container',
  configForm: () => <p>一个普普通通，没有内置样式的容器</p>,
};

export default EmptyContainer;
